export const newFeatures = {
  isUpdateEtaNewManage: 'IS_UPDATE_ETA_NEW_MANAGE',
  isUpdateEtaNewEdit: 'IS_UPDATE_ETA_NEW_EDIT',
  isSavedSearchNew: 'IS_SAVED_SEARCH_NEW',
  isPendingOfferNew: 'IS_PENDING_OFFER_NEW',
  isFilterByJobTypeNew: 'IS_FILTER_BY_JOB_TYPE_NEW',
  isBackhaulsNew: 'IS_BACKHAULS_NEW',
};
